import { useCallback } from 'react';
import { useTranslation } from '@/lib/i18n';
import { SearchSelectField } from '@/components/ui';
import { searchMembers, resolveMember } from '../lib/memberSearch';

interface MemberSelectorProps {
  value: string | null;
  disabled?: boolean;
  errorMessage?: string | null;
  onChange: (userId: string | null) => void;
}

/** ID55 주문자 회원 검색 — 이름/이메일/연락처로 회원을 찾아 userId 를 선택한다. */
export const MemberSelector = ({
  value,
  disabled,
  errorMessage,
  onChange,
}: MemberSelectorProps) => {
  const { t } = useTranslation('manualOrder');
  const loadOptions = useCallback(
    (q: string, page: number) => searchMembers(q, page),
    [],
  );
  const resolveOption = useCallback((v: string) => resolveMember(v), []);

  return (
    <SearchSelectField
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      resolveOption={resolveOption}
      placeholder={t('manualOrder.member.placeholder')}
      emptyMessage={t('manualOrder.member.empty')}
      loadingMessage={t('manualOrder.member.loading')}
      testId="manual-order-member"
      {...(disabled !== undefined ? { disabled } : {})}
      {...(errorMessage !== undefined && errorMessage !== null ? { errorMessage } : {})}
    />
  );
};
